import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import Container from '@components/Container'
import Box from '@components/Box'
import { SH3, STypographyLarge } from '@components/Typography'
import { above } from '@styles/mixins/breakpoints'

const SBannerContainer = styled(Container)<{ bgColor?: string }>`
  min-height: 220px;
  height: 603px;
  padding: 32px 20px 339px 20px;
  position: relative;
  background: ${({ bgColor }) => bgColor};
  border-radius: 8px;

  ${above('md')(css`
    height: auto;
    display: flex;
    padding: 32px 226px 32px 32px;
  `)}
  ${above('xl')(css`
    display: flex;
    padding: 52px 476px 52px 44px;
  `)}
`

interface IProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  text: string
  image?: string
  bgColor?: string
}

const SImage = styled.img`
  position: absolute;
  width: auto;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  border-radius: 8px;
  ${above('md')(css`
    transform: none;
    right: 0;
  `)}
`

const SmallBanner: React.FC<IProps> = ({ title, text, image, bgColor }) => {
  return (
    <SBannerContainer mb={{ xs: 0, md: '44px' }} bgColor={bgColor}>
      <Box
        className="bannerContentContainer"
        display="flex"
        flexDirection="column"
        width="100%"
        justifyContent="center"
        alignItems="flex-start"
        position="relative"
        zIndex={1}
      >
        <SH3
          className="bannerTitle"
          color="graphite"
          width="100%"
          mb={{ xs: '12px', md: '12px' }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <STypographyLarge mb={{ xs: '24px', md: 0 }} className="bannerText" color="graphite" width="100%">
          {text}
        </STypographyLarge>
      </Box>

      <Box>
        <SImage src={image} />
      </Box>
    </SBannerContainer>
  )
}

export default SmallBanner
